const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");
const { default: axiosInstance } = require("src/utils/axios");


export const getOcppLogs = createAsyncThunk('getOcpp/logs', async (params, { rejectWithValue }) => {
    try{
        const response =  await axiosInstance.get('ocpp-logs', {
            params
        })
        return response.data
    } catch (err) {
        return rejectWithValue(err)
    }
});

const initialState = {
    ocppLogs:[],
    loading: true
}


const slice = createSlice({
    name: 'logs',
    initialState,
    reducers: {
        resetLogs: (state, action) => {
           state.ocppLogs = []
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getOcppLogs.pending, (state, action) => {
            state.loading = true
        }) 
        .addCase(getOcppLogs.fulfilled, (state, action) => {
            state.loading = false;
            state.ocppLogs = action.payload.data
        })
        .addCase(getOcppLogs.rejected, (state, action) => {
            state.loading = false
        }) 
    }
})

export const { resetLogs } = slice.actions;
export default slice.reducer;